import { FilterValues } from "../components/DynamicFilterForm";
import { downloadPost } from "./downloadPost";

export type ExportRequestsBody = {
  scope?: "all" | "my" | "approval";
  user_id?: string;
  template_short_name?: string;
  filter?: FilterValues;
};

/**
 * Calls the backend xlsx export endpoint with the current filter values and
 * triggers a browser download. The backend applies the same filters as the
 * list views, so the file contains exactly the filtered records.
 */
export async function exportRequestsToExcel(
  body: ExportRequestsBody,
  fallbackFileName = "requests.xlsx"
): Promise<void> {
  return downloadPost("/api/main/export-requests/", body, fallbackFileName);
}
